import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import { getAuth, dashboardPathForRole } from '../auth/session'

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
    meta: { guestOnly: true }
  },
  {
    path: '/dashboard/asds',
    redirect: '/dashboard/rater'
  },
  {
    path: '/dashboard/admin',
    name: 'dashboard-admin',
    component: () => import(/* webpackChunkName: "dash-admin" */ '../views/dashboards/AdminDashboard.vue'),
    meta: { requiresAuth: true, roleids: [1] }
  },
  {
    path: '/dashboard/school',
    name: 'dashboard-school',
    component: () => import(/* webpackChunkName: "dash-school" */ '../views/dashboards/SchoolDashboard.vue'),
    meta: { requiresAuth: true, roleids: [2] }
  },
  {
    path: '/dashboard/rater',
    name: 'dashboard-rater',
    component: () => import(/* webpackChunkName: "dash-rater" */ '../views/dashboards/RaterDashboard.vue'),
    meta: { requiresAuth: true, roleids: [3, 4] }
  },
  {
    path: '/dashboard/division',
    redirect: '/dashboard/rater'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  const auth = getAuth()



  if (to.meta.requiresAuth) {
    if (!auth) {
      return { path: '/' }
    }
    if (to.meta.roleids && !to.meta.roleids.includes(Number(auth.roleid))) {
      return dashboardPathForRole(auth.roleid)
    }
  }

  if (to.meta.guestOnly && auth) {
    return dashboardPathForRole(auth.roleid)
  }

  return true
})

export default router
